export const HEBREW_MONTHS = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
] as const;

/** DOM order for RTL grid: Sunday (right) → Saturday (left) */
export const WEEKDAY_LABELS = ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'] as const;

export const MIN_BIRTH_YEAR = 1900;

export const texts = {
  placeholder: 'בחר תאריך לידה',
  prevMonth: 'חודש קודם',
  nextMonth: 'חודש הבא',
  yearSelect: 'בחירת שנה',
  monthSelect: 'בחירת חודש',
};
